import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-multirisque-immeuble-pno',
  standalone: true,
  imports: [CommonModule, RouterModule, PageLayoutComponent],
  templateUrl: './assurance-multirisque-immeuble-pno.component.html',
  styleUrls: ['./assurance-multirisque-immeuble-pno.component.scss']
})
export class AssuranceMultirisqueImmeublePnoComponent {
  title = 'Assurance Multirisque Immeuble - MRI - PNO';
  subtitle = '';
  phoneNumber = '01 43 27 12 43';
  heroImage = 'assets/static_pages_images/AMI-PNO.jpg';
  
  breadcrumbs = [
    { label: 'Particuliers', link: undefined },
    { label: 'Assurance MRI - PNO', link: undefined }
  ];

  prevPage = { 
    title: 'Assurance Auto Temporaire',
    link: '/assurance-auto-temporaire'
  };

  nextPage = { 
    title: 'Assurance Loyers Impayés',
    link: '/assurance-loyers-impayes'
  };

  // Partners logos for carousel
  partners = [
    { name: 'Generali', logo: 'assets/logos/generali.png' },
    { name: 'April', logo: 'assets/logos/april.png' },
    { name: 'SPVIE AXA', logo: 'assets/logos/spvie.png' },
    { name: 'Swiss Life', logo: 'assets/logos/SWISSLIFE.PNG' },
    { name: 'Insured', logo: 'assets/logos/insured.png' },
    { name: 'Progeas', logo: 'assets/logos/progeas.png' },
    { name: 'Entoria', logo: 'assets/logos/entoria.png' },
  ];

  constructor(private router: Router) {}

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }
}
